import { parseApiNumber } from '@vestigas/utils';

type PaymentTermInput = {
  percentage?: number | string | null;
};

/**
 * Whether a payment term is an early payment discount (Skonto): it has a
 * non-zero percentage. A term with only a period (e.g. "30 days net") is not.
 */
export function hasEarlyPaymentDiscount(term: PaymentTermInput) {
  return Boolean(parseApiNumber(term.percentage));
}

/**
 * The contract's early payment discount: its first payment term with a
 * discount. Contracts can store several payment terms, but the form and the
 * details page show exactly one.
 */
export function findEarlyPaymentDiscount<
  Terms extends readonly PaymentTermInput[],
>(paymentTerms: Terms | null | undefined): Terms[number] | undefined {
  return paymentTerms?.find(hasEarlyPaymentDiscount);
}

/**
 * Removes payment terms that are not an early payment discount. The form
 * always holds one payment term for its inputs; an untouched one must not be
 * saved as a 0 % discount. The API replaces the stored terms with the array it
 * receives, so an empty array clears a previously saved discount.
 */
export function stripEmptyPaymentTerms<T extends PaymentTermInput>(
  paymentTerms: T[] | null | undefined,
) {
  return (paymentTerms ?? []).filter(hasEarlyPaymentDiscount);
}
